export enum TableBarChartDataType {
  MEETINGS_BY_REP = 'MEETINGS_BY_REP',
  CALLS_BY_REP = 'CALLS_BY_REP',
  URL = 'URL',
  REP = 'REP',
  TAG = 'TAG',
  DEFLECTION_RATE_BY_PLAYBOOK = 'DEFLECTION_RATE_BY_PLAYBOOK',
  CSAT_BY_TEAMMATE = 'CSAT_BY_TEAMMATE',
}

export interface ITableBarChartConfig {
  title: string
  subtitle?: string
  column_titles: string[]
  color?: string
  tooltip_text: string
}
